import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Spin, message } from 'antd'
import NewPasswordForm from './NewPasswordForm'
import { useDispatch } from 'react-redux'
import { reset } from '../../reducers/authReducer'

const ResetPasswordPage = () => {
  const { token } = useParams()
  const [loading, setLoading] = useState(true)
  const [valid, setValid] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    const validateToken = async (token) => {
      try {
        await dispatch(reset(token))
        setValid(true)
      } catch (err) {
        message.error('Token invalid or expired')
      } finally {
        setLoading(false)
      }
    }
    validateToken(token)
  }, [token])

  if (loading) return <Spin />

  return valid ? <NewPasswordForm token={token} /> : <p>Link expired</p>
}

export default ResetPasswordPage
